module.exports = __webpack_public_path__ + "static/media/Golos_Text_Bold.58e37dc6.ttf";